import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Box, Chip } from '@mui/material';
import { LocationOn, Business, Home } from '@mui/icons-material';
import '../styles/animations.css';

const Projects = () => {
  const projects = [
    {
      id: 1,
      name: '32nd Avenue',
      type: 'Commercial',
      location: 'Sector 15, Gurgaon',
      description: 'Premium commercial project featuring high-end retail spaces, F&B outlets, and designer showrooms. The project includes The High Line and The Galleries sections.',
      features: [
        'Premium retail spaces',
        'International F&B brands',
        'Designer showrooms',
        'Rooftop restaurants',
        '24/7 security'
      ],
      image: '/images/32nd-avenue.jpg'
    },
    {
      id: 2,
      name: 'DLF Privana',
      type: 'Residential',
      location: 'Sector 76-77, Gurgaon',
      description: 'Luxury residential project offering 4 BHK apartments and penthouses with world-class amenities and stunning views.',
      features: [
        '4 BHK Luxury Apartments',
        'Premium Penthouses',
        'State-of-the-art Clubhouse',
        '80% Green Areas',
        '24/7 Security'
      ],
      image: '/images/dlf-privana.jpg'
    },
    {
      id: 3,
      name: 'Emaar Gurgaon Greens',
      type: 'Residential',
      location: 'Sector 102, Gurgaon',
      description: 'Modern residential development offering 3 BHK apartments with servant quarters and penthouse options in a green environment.',
      features: [
        '3 BHK + Servant Quarter',
        'Penthouse Options',
        'Swimming Pool',
        'Clubhouse',
        'Sports Facilities'
      ],
      image: '/images/emaar-gurgaon-greens.jpg'
    },
    {
      id: 4,
      name: '3B Homes',
      type: 'Residential',
      location: 'Sector 95, Gurgaon',
      description: 'Premium residential plots and homes in a well-planned community with modern amenities.',
      features: [
        'Residential Plots',
        'Modern Infrastructure',
        'Power Backup',
        'Security System',
        'Community Spaces'
      ],
      image: '/images/3b-homes.jpg'
    }
  ];

  return (
    <Container sx={{ py: 8 }}>
      <Typography 
        variant="h2" 
        align="center" 
        gutterBottom
        className="animate-fadeInUp"
      >
        Our Projects
      </Typography>
      <Typography 
        variant="h5" 
        align="center" 
        color="text.secondary" 
        paragraph
        className="animate-fadeInUp delay-100"
      >
        Discover our premium residential and commercial properties
      </Typography>
      
      <Grid container spacing={4} sx={{ mt: 4 }}>
        {projects.map((project, index) => (
          <Grid item xs={12} key={project.id}>
            <Card 
              sx={{ display: { md: 'flex' }, height: '100%' }}
              className={`animate-slideInFromRight hover-scale delay-${index * 100}`}
            >
              <CardMedia
                component="img"
                sx={{ width: { md: 400 } }}
                image={project.image}
                alt={project.name}
              />
              <Box sx={{ flex: 1 }}>
                <CardContent>
                  <Typography variant="h4" gutterBottom>
                    {project.name}
                  </Typography>
                  
                  <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
                    <Chip 
                      icon={project.type === 'Commercial' ? <Business /> : <Home />} 
                      label={project.type}
                      color="primary"
                    />
                    <Chip 
                      icon={<LocationOn />} 
                      label={project.location}
                      variant="outlined"
                    />
                  </Box>

                  <Typography variant="body1" paragraph>
                    {project.description}
                  </Typography>

                  <Typography variant="h6" gutterBottom>
                    Key Features:
                  </Typography>
                  <Grid container spacing={1}>
                    {project.features.map((feature, index) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <Typography variant="body2">• {feature}</Typography>
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Projects; 